<template>
    <drop-zone v-bind="$attrs" :class="add ? 'media-library-add' : 'media-library-replace'" :validation-accept="(validationRules || {}).accept" @clicked="handleClick" @dropped="$emit('dropped', $event)">
        <button
            slot-scope="{ hasDragObject, isDropTarget, isValid }"
            :class="`group media-library-dropzone
                ${hasDragObject && !isDropTarget ? 'media-library-dropzone-drag' : ''}
                ${hasDragObject && isDropTarget ? 'media-library-dropzone-drop' : ''}
                ${add ? 'media-library-dropzone-add' : 'media-library-dropzone-replace'}
                ${!isValid && hasDragObject ? 'disabled' : ''}
            `"
            type="button"
        >
            <input ref="fileInputRef" :accept="(validationRules || {}).accept ? (validationRules || {}).accept.join(',') : undefined" :dusk="add ? 'main-uploader' : 'uploader'" :multiple="multiple" class="media-library-hidden" type="file" @change.stop="handleChange" />

            <div v-show="!add" class="media-library-placeholder">
                <icon-button v-if="isValid || !hasDragObject" :icon="add ? 'add' : 'replace'" level="info" />
                <icon-button v-else icon="not-allowed" level="warning" />

                <div v-if="uploadInfo" :class="`media-library-progress-wrap ${uploadInfo.hasFinishedUploading ? '' : 'media-library-progress-wrap-loading'}`">
                    <progress :value="uploadInfo.uploadProgress" class="media-library-progress" max="100" />
                </div>
            </div>

            <!--<div class="media-library-icon">-->
            <!--    <svg aria-hidden="true" stroke="currentColor" viewBox="0 0 24 24">-->
            <!--        <path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>-->
            <!--    </svg>-->
            <!--</div>-->

            <!--<div v-if="add" class="media-library-help">-->
            <!--    <span>Add Media</span>-->
            <!--    &lt;!&ndash;<span>or drag & drop your media</span>&ndash;&gt;-->
            <!--    <span style="margin-left: 0.5rem; font-size: 12px">({{ maxItems }} max)</span>-->
            <!--</div>-->
        </button>
    </drop-zone>
</template>

<script>
import DropZone from "@spatie/media-library-pro-vue2/src/DropZone.vue"
import ItemErrors from "@spatie/media-library-pro-vue2/src/ItemErrors.vue"
import IconButton from "@spatie/media-library-pro-vue2/src/components/IconButton.vue"
import { buildRuleHelpText } from "@spatie/media-library-pro-core"

export default {
    mounted() {
        if (typeof this.$refs.fileInputRef != "undefined") {
            this.$root.$on("addMediaToPost", () => this.$refs.fileInputRef.click())
        }
    },

    props: {
        add: { default: true, type: Boolean },
        uploadInfo: { required: false, type: Object },
        multiple: { default: false, type: Boolean },
        validationRules: { required: false, type: Object },
        maxItems: { required: false, type: Number },
    },

    emits: ["changed", "dropped"],

    components: { DropZone, IconButton, ItemErrors },

    data: () => ({ window }),

    methods: {
        buildRuleHelpText,

        handleClick() {
            if (this.$refs.fileInputRef) {
                this.$refs.fileInputRef.click()
            } else {
                console.error("File input reference is undefined.")
            }
        },

        handleChange(event) {
            this.$emit("changed", event)
            if (this.$refs.fileInputRef) {
                this.$refs.fileInputRef.value = ""
            }
        },
    },
}
</script>
